import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import { Page, Section } from 'react-page-layout';
import ErrorImageCritical from 'components/error-image/critical';
import t, { Trans, TransMD } from 'translations/index';
import linkToHome from 'util/misc/link-to-home';

class Error extends PureComponent {
    static propTypes = {
        isDesktop: PropTypes.bool.isRequired,
        subtitle: PropTypes.any,
        title: PropTypes.any,
        activeRegion: PropTypes.object,
        description: PropTypes.any,
        setBreadcrumbs: PropTypes.func.isRequired,
        viewportMqWidth: PropTypes.number.isRequired,
        lastRoute: PropTypes.object,
        setMainContentIsLoaded: PropTypes.func.isRequired,
    };

    state = {
        contentOffset: 0,
    };

    componentDidMount() {
        // small hack to unflag also global variables
        window.__is_not_found__ = false;
        this.updateOffset();
        this.props.setMainContentIsLoaded({ isLoaded: true });
        this.props.setBreadcrumbs({
            breadcrumbs: [{
                url: linkToHome(this.props.activeRegion),
                name: t('breadcrumbs.overview'),
            }],
        });
    }

    componentDidUpdate({ viewportMqWidth }, { viewportMqWidth: viewportMqWidthNew }) {
        if (viewportMqWidth !== viewportMqWidthNew) {
            this.updateOffset();
        }
    }

    /**
     * Create an offset top to center the error message on the image
     */
    updateOffset() {
        const { image, content, description } = this;
        const titleHeight = content.offsetHeight - description.offsetHeight;
        const contentOffset = this.props.isDesktop ? (image.offsetHeight - titleHeight) / 2 : 0;

        this.setState({
            contentOffset: `${ contentOffset }px`,
        });
    }

    render() {
        const { isDesktop, subtitle, title, description } = this.props;
        const { contentOffset } = this.state;

        return (
            <Page layout={isDesktop ? 'one-column' : 'full-width'} facet="narrow">
                <Section slot="content">
                    <div className="page">
                        <div className="page--content">
                            <div className="page-error page-error__description page-error__dynamic">
                                <div className="page-error--body">
                                    <div
                                        className="page-error--image"
                                        ref={ref => {
                                            this.image = ref;
                                        }}
                                    >
                                        <ErrorImageCritical alt={t(subtitle)} className={'page-error--img'}/>
                                    </div>
                                    <div
                                        className="page-error--content"
                                        ref={ref => {
                                            this.content = ref;
                                        }}
                                        style={{ top: contentOffset }}
                                    >
                                        {subtitle && (
                                            <h2 className="u-reset page-error--subtitle">
                                                <Trans path={subtitle}/>
                                            </h2>
                                        )}

                                        <h1 className="page-error--title">
                                            <Trans path={title}/>
                                        </h1>

                                        {description && (
                                            <div
                                                className="page-error--description cms-richtext"
                                                ref={ref => {
                                                    this.description = ref;
                                                }}
                                            >
                                                <TransMD path={description}/>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Section>
            </Page>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isDesktop: 'viewport.isDesktop',
        viewportMqWidth: 'viewport.mq.width',
        activeRegion: 'region.active',
        lastRoute: 'router.lastRoute',
    }),
    reduxUtils.mapDispatchToProps({
        setBreadcrumbs: 'breadcrumbs.set',
        setMainContentIsLoaded: 'main-content.setIsLoaded',
    }),
)(Error);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/templates/error/index.js